/** Consentement à la politique de collecte Nexxus lors de l’activation. */

export const INSTALL_DATA_CONSENT_KEY = 'nexxus_install_data_consent_v1';

export interface InstallDataConsentRecord {
  accepted: true;
  version: string;
  accepted_at: string;
}

export function getInstallDataConsent(): InstallDataConsentRecord | null {
  try {
    const raw = localStorage.getItem(INSTALL_DATA_CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as InstallDataConsentRecord;
    if (parsed?.accepted === true && typeof parsed.version === 'string') return parsed;
    return null;
  } catch {
    return null;
  }
}

export function hasInstallDataConsent(expectedVersion?: string): boolean {
  const record = getInstallDataConsent();
  if (!record) return false;
  if (expectedVersion && record.version !== expectedVersion) return false;
  return true;
}

export function setInstallDataConsent(version: string): boolean {
  const record: InstallDataConsentRecord = {
    accepted: true,
    version,
    accepted_at: new Date().toISOString(),
  };
  try {
    localStorage.setItem(INSTALL_DATA_CONSENT_KEY, JSON.stringify(record));
    return hasInstallDataConsent(version);
  } catch {
    return false;
  }
}
